export default "__VITE_ASSET__ZupoVdRT__"